// extracted by mini-css-extract-plugin
export default {"MainCont":"Assembly_MainCont__SsfwL","RightCont":"Assembly_RightCont__wW5NH"};